import BestTraveler1Profile from "../../Assets/images/BestTraveler1-profile.png"
import BestTraveler2Profile from "../../Assets/images/BestTraveler2-profile.png"
import BestTraveler3Profile from "../../Assets/images/BestTraveler3-profile.png"
import BestTraveler4Profile from "../../Assets/images/BestTraveler4-profile.png"
import BestTravelerLocation1 from "../../Assets/images/BestTraveler-location1.png"
import BestTravelerLocation2 from "../../Assets/images/BestTraveler-location2.png"
import BestTravelerLocation3 from "../../Assets/images/BestTraveler-location3.png"
import BestTravelerLocation4 from "../../Assets/images/BestTraveler-location4.png"
export const bestTravelers = [{
        name: "Raju Mullah",
        username: "@rajumullah",
        profileImage: BestTraveler1Profile,
        location: BestTravelerLocation1
    },

    {
        name: "Zaire Vetrovs",
        username: "@zairevetrovs",
        profileImage: BestTraveler2Profile,
        location: BestTravelerLocation2
    },
    {
        name: "Marcus Dias",
        username: "@marcsdias",
        profileImage: BestTraveler3Profile,
        location: BestTravelerLocation3
    },
    {
        name: "Davis Schleifer",
        username: "@davisschleifer",
        profileImage: BestTraveler4Profile,
        location: BestTravelerLocation4
    }

]